var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global TYAPP_SURVEYS */

// init namespace
if ((typeof TYAPP_SURVEYS === 'undefined' ? 'undefined' : _typeof(TYAPP_SURVEYS)) !== 'object') {
	TYAPP_SURVEYS = {}; // eslint-disable-line no-global-assign
}

TYAPP_SURVEYS.dependentQuestions = [];
TYAPP_SURVEYS.dataTypes = {};
TYAPP_SURVEYS.questionsInGroups = {};
TYAPP_SURVEYS.cqMap = {}; // filled in review_form_content_custom_questions.html
TYAPP_SURVEYS.third_party_activation_rules = {};

/**
 * Abstract basic question element
 */

var BasicQuestionElement = function () {
	/**
  * @param id, Question id as stored in the database
  * @param inputId, DOM input element id (usually hidden)
  * @param componentId, parent DOM div element id
  */
	function BasicQuestionElement(id, inputId, componentId) {
		_classCallCheck(this, BasicQuestionElement);

		this.id = id;
		this.inputId = inputId;
		this.componentId = componentId;
	}

	/**
  * Returns the input element for this question.
  * @returns {jQuery|HTMLElement}
  */


	_createClass(BasicQuestionElement, [{
		key: 'getInputElement',
		value: function getInputElement() {
			return $('#' + this.inputId);
		}

		/**
   * Given a dependantQuestion as parameter return false if the actual BasicQuestion value is compatible, otherwise
   * returns true.
   * @param dependantQuestion
   */

	}, {
		key: 'isDependandQuestionLocked',
		value: function isDependandQuestionLocked(dependantQuestion) {
			var isLocked = true;
			var actualValue = this.getInputElement().val();
			dependantQuestion.parentAnswersIdxs[this.id].forEach(function (index) {
				if (actualValue === index) {
					isLocked = false;
				}
			});
			return isLocked;
		}
	}]);

	return BasicQuestionElement;
}();

/**
 * A Basic question that has an integer value as answer.
 */


var ScoreQuestionElement = function (_BasicQuestionElement) {
	_inherits(ScoreQuestionElement, _BasicQuestionElement);

	function ScoreQuestionElement() {
		_classCallCheck(this, ScoreQuestionElement);

		return _possibleConstructorReturn(this, (ScoreQuestionElement.__proto__ || Object.getPrototypeOf(ScoreQuestionElement)).apply(this, arguments));
	}

	_createClass(ScoreQuestionElement, [{
		key: 'isDependantQuestionLocked',

		/**
   * dependantQuestion is locked if the value of this score question is not in dependantQuestion.parentAnswersIdxs array.
   * @param dependantQuestion
   * @returns {boolean}
   */
		value: function isDependantQuestionLocked(dependantQuestion) {
			var isLocked = true;
			var actualValue = parseInt(this.getInputElement().val());
			dependantQuestion.parentAnswersIdxs[this.id].forEach(function (index) {
				if (actualValue === index) {
					isLocked = false;
				}
			});
			return isLocked;
		}
	}]);

	return ScoreQuestionElement;
}(BasicQuestionElement);

/**
 * A Basic Question that has a limited set of options as answer.
 */


var DropDownQuestionElement = function (_BasicQuestionElement2) {
	_inherits(DropDownQuestionElement, _BasicQuestionElement2);

	/**
  *
  * @param id, Question id as stored in the database
  * @param inputId, DOM input element id (usually hidden)
  * @param componentId, parent DOM div element id
  * @param options, possible values for this dropdown
  */
	function DropDownQuestionElement(id, inputId, componentId, options) {
		_classCallCheck(this, DropDownQuestionElement);

		var _this2 = _possibleConstructorReturn(this, (DropDownQuestionElement.__proto__ || Object.getPrototypeOf(DropDownQuestionElement)).call(this, id, inputId, componentId));

		_this2.options = options;
		_this2.optionsIndex = {};
		_this2._precalculateOptionsIndexes();
		return _this2;
	}

	/**
  * Creates an hashmap for the options, given the value returns the index in the options array.
  * @private
  */


	_createClass(DropDownQuestionElement, [{
		key: '_precalculateOptionsIndexes',
		value: function _precalculateOptionsIndexes() {
			var _this3 = this;

			this.options.forEach(function (option, index) {
				_this3.optionsIndex[option] = index;
			});
		}

		/**
   * Returns the index of the actually selected value for this element.
   * @returns {undefined}
   */

	}, {
		key: 'getActualValueIndex',
		value: function getActualValueIndex() {
			var actualValueIndex = -1;

			var actualValue = this.getInputElement().val();
			if (actualValue !== '') {
				actualValueIndex = this.optionsIndex[actualValue];
			}
			return actualValueIndex;
		}

		/**
   * dependantQuestion is locked index of the actually selected value for this question is not in
   * dependantQuestion.parentAnswersIdxs array.
   * @param dependantQuestion
   * @returns {boolean}
   */

	}, {
		key: 'isDependantQuestionLocked',
		value: function isDependantQuestionLocked(dependantQuestion) {
			var isLocked = true;
			var actualValueIndex = this.getActualValueIndex();
			dependantQuestion.parentAnswersIdxs[this.id].forEach(function (index) {
				if (actualValueIndex === index) {
					isLocked = false;
				}
			});
			return isLocked;
		}
	}]);

	return DropDownQuestionElement;
}(BasicQuestionElement);

/**
 * A Dropdown Question that uses select values as options.
 */


var SelectQuestionElement = function (_DropDownQuestionElem) {
	_inherits(SelectQuestionElement, _DropDownQuestionElem);

	/**
  * SelectQuestionElement loads the options from the select dom element instead taking it as a parameter.
  * @param id, Question id as stored in the database
  * @param inputId, DOM select element id
  * @param componentId, parent DOM div element id
  */
	function SelectQuestionElement(id, inputId, componentId) {
		_classCallCheck(this, SelectQuestionElement);

		return _possibleConstructorReturn(this, (SelectQuestionElement.__proto__ || Object.getPrototypeOf(SelectQuestionElement)).call(this, id, inputId, componentId, []));
	}

	/**
  * Returns a select instead of an inpu
  * @returns {jQuery|HTMLElement}
  */


	_createClass(SelectQuestionElement, [{
		key: 'getInputElement',
		value: function getInputElement() {
			return $('select[name=' + this.inputId + ']');
		}

		/**
   * Returns the selected option's index for the select.
   * @returns {number}
   */

	}, {
		key: 'getActualValueIndex',
		value: function getActualValueIndex() {
			/**
    * The select has an empty option.
    */
			return this.getInputElement().prop('selectedIndex') - 1;
		}
	}]);

	return SelectQuestionElement;
}(DropDownQuestionElement);

/**
 *
 * @type {string[]}
 */


var TRAVELLER_TYPE_SUPPORTED_VALUES = ['business', 'family', 'couple', 'friends', 'single'];

var CLUSTER_RECOMMEND_SUPPORTED_VALUES = ['yes', 'no'];

/**
 * Search for activated parents between BasicQuestions
 */
var BASIC_QUESTIONS_MAP = {
	'847e65ab-029d-44b3-af9d-2b9dedb143a2': new ScoreQuestionElement('847e65ab-029d-44b3-af9d-2b9dedb143a2', 'overall_score', 'overall_score_component'),
	'5aad140b-e6d6-480c-89c0-781dbd548415': new DropDownQuestionElement('5aad140b-e6d6-480c-89c0-781dbd548415', 'traveller_type_value', 'type_of_trip_component', TRAVELLER_TYPE_SUPPORTED_VALUES),
	'6a2cbd63-6733-423e-ba97-e14d2abb2552': new SelectQuestionElement('6a2cbd63-6733-423e-ba97-e14d2abb2552', 'traveller_nationality', 'traveller_nationality_component'),
	'99b9bfc1-35b1-40f1-adef-d9bc6967d96c': new ScoreQuestionElement('99b9bfc1-35b1-40f1-adef-d9bc6967d96c', 'net_promoter_score', 'net_promoter_score_component'),
	'ba969f03-3ba5-4cd2-9792-7aa2ad913c39': new DropDownQuestionElement('ba969f03-3ba5-4cd2-9792-7aa2ad913c39', 'cluster_recommended_value', 'recommend_component', CLUSTER_RECOMMEND_SUPPORTED_VALUES)
};

// used in review_html_head template
var prepareForPrint = function (dependingOnMsg) {
	// eslint-disable-line no-unused-vars
	// all possible dependable questions map (cq and basic).
	var dependableQuestionsMap = jQuery.extend({}, TYAPP_SURVEYS.cqMap, BASIC_QUESTIONS_MAP);
	// component id -> question uuid map to find needed dependant question
	var componentQuestionMap = {};
	Object.keys(dependableQuestionsMap).forEach(function (key) {
		var componentId = dependableQuestionsMap[key].componentId;
		componentQuestionMap[componentId] = key;
	});

	// loop through all questions component in UI and prepend indexes
	var allComponents = $('.control-group.question');
	allComponents.each(function (idx) {
		var showIdx = idx + 1;
		$(this).find('.control-label label').prepend(showIdx + '. ');
		var componentId = this.id;
		if (componentId && componentQuestionMap[componentId]) {
			var questionId = componentQuestionMap[componentId];
			var question = dependableQuestionsMap[questionId];
			if (question) {
				question.idx = showIdx;
			}
		}
	});

	// loop through all dependent questions and prepend info (parent indexes) in UI
	TYAPP_SURVEYS.dependentQuestions.forEach(function (q) {
		var dependentQ = dependableQuestionsMap[q.id];
		if (dependentQ && dependentQ.componentId && dependentQ.parentQuestionIds) {
			var parents = dependentQ.parentQuestionIds.map(function (parentId) {
				var parentAnswers = dependentQ.parentAnswersIdxs && dependentQ.parentAnswersIdxs[parentId];
				var parentQ = dependableQuestionsMap[parentId];
				return {
					id: parentQ.id,
					idx: parentQ.idx,
					label: parentQ.label,
					answers: Array.isArray(parentAnswers) && parentAnswers.join(', ')
				};
			});
			var infoElement = '<p class="print-info">' + dependingOnMsg + ': ' + parents.map(function (parent) {
				return parent.idx;
			}).join(', ') + '</p>';
			$('#' + dependentQ.componentId + ' .control-label').append(infoElement);
		}
	});
};

var updateQuestionsVisibility = function (pagination, readOnly) {
	var visibleQuestionsInGroups = jQuery.extend({}, TYAPP_SURVEYS.questionsInGroups);
	var visibilityChanged = false;

	// hiding/showing dependent questions

	var _loop = function (i) {
		var dependentQuestion = TYAPP_SURVEYS.dependentQuestions[i];
		var questionId = dependentQuestion.id;
		var groupId = dependentQuestion.groupId;
		var parentQuestionIds = dependentQuestion.parentQuestionIds || [];
		var parentAnswersIdxs = dependentQuestion.parentAnswersIdxs || {};
		var visibleParentIds = [];
		var visibleQuestionSiblings = void 0,
		    customQuestion = void 0,
		    section = void 0;

		/**
   * Search for activated parents between Custom questions
   * @type {*|Array}
   */
		var activatedParents = $.map(parentQuestionIds || [], function (parentQuestionId) {
			// eslint-disable-line no-loop-func
			var inputs = $('[name="' + parentQuestionId + '"]');
			var parentQuestionDataType = TYAPP_SURVEYS.dataTypes[parentQuestionId];
			var valueFound = false;
			var selectedValues = [];

			var parentQuestion = $('#' + parentQuestionId + '-panel');
			if (parentQuestion.length > 0) {
				visibleParentIds.push(parentQuestionId);
				if (parentQuestion.hasClass('parent_not_selected')) {
					return null;
				}

				if (parentQuestionDataType === 'checkboxes' || parentQuestionDataType === 'radios') {
					for (var j = 0; j < inputs.length; j++) {
						var checkbox = $(inputs[j]);
						if (checkbox.is(':checked')) {
							selectedValues.push(parseInt(checkbox.val()));
						}
					}
				} else {
					selectedValues.push(parseInt(inputs.val()));
				}

				if (selectedValues && selectedValues.length > 0) {
					for (var _j = 0; _j < parentAnswersIdxs[parentQuestionId].length; _j++) {
						var activatingValue = parentAnswersIdxs[parentQuestionId][_j];
						if ($.inArray(activatingValue, selectedValues) > -1) {
							valueFound = true;
							break;
						}
					}
				}

				if (valueFound) {
					return parentQuestionId;
				} else {
					return null;
				}
			} else {
				return null;
			}
		});

		/**
   * Search for activated parents between Basic Questions
   * @type {*|Array}
   */
		for (var j = 0; j < dependentQuestion.parentQuestionIds.length; j++) {
			if (BASIC_QUESTIONS_MAP[dependentQuestion.parentQuestionIds[j]] !== undefined) {
				/**
     * Basic questions are always visible, so add it to the list.
     */
				visibleParentIds.push(dependentQuestion.parentQuestionIds[j]);

				/**
     * Check if the basic question is not locking the current dependentQuestion
     */
				if (!BASIC_QUESTIONS_MAP[dependentQuestion.parentQuestionIds[j]].isDependantQuestionLocked(dependentQuestion)) {
					if (!activatedParents) {
						activatedParents = [];
					}
					activatedParents.push(dependentQuestion.parentQuestionIds[j]);
				}
			}
		}

		if (!activatedParents || activatedParents.length !== visibleParentIds.length) {
			customQuestion = $('#' + questionId + '-panel');
			customQuestion.addClass('parent_not_selected');

			// TM-6565: please keep this line as parent_not_selected is processed
			// only for paged questionnaires
			customQuestion.css('display', 'none');

			visibleQuestionSiblings = customQuestion.siblings('.question:not(.invisible-question):not(.parent_not_selected):visible');

			// hide subsection only if there are no other visible siblings
			if (!visibleQuestionSiblings.length) {
				section = customQuestion.closest('.questions, .submit, .question_section');
				section.hide();
			}

			// WANALYTIC-4850: avoid submitting answers to answered but then hidden questions
			customQuestion.find(':input').prop('disabled', true);

			visibilityChanged = true;

			visibleQuestionsInGroups[groupId] -= 1;
		} else {
			customQuestion = $('#' + questionId + '-panel');
			customQuestion.removeClass('parent_not_selected');

			// TM-2044: preventing the paginator to jump randomly to dependent questions
			if (!pagination) {
				customQuestion.css('display', 'block');

				section = customQuestion.closest('.questions, .submit, .question_section');

				section.show();
			}

			// WANALYTIC-4850: avoid submitting answers to answered but then hidden questions
			if (!readOnly) {
				if (!customQuestion.hasClass('not-editable-question')) {
					customQuestion.find(':input').prop('disabled', false);
				}
			}

			visibilityChanged = true;
		}
	};

	for (var i = 0; i < TYAPP_SURVEYS.dependentQuestions.length; i++) {
		_loop(i);
	}

	if (pagination && visibilityChanged) {
		$('#review_form').SurveyPaginator().refreshQuestions();
	}
};

TYAPP_SURVEYS.prepareVisibilityUpdater = function (pagination, readOnly) {
	$('#cq-questions input').change(function () {
		updateQuestionsVisibility(pagination, readOnly);
	});

	$('#cq-questions select').change(function () {
		updateQuestionsVisibility(pagination, readOnly);
	});

	/**
  * Callback for Traveller Nationality basic question.
  */
	$('select[name=traveller_nationality]').change(function () {
		updateQuestionsVisibility(pagination, readOnly);
	});

	/**
  * Callback for Traveller Type basic question.
  */
	$('#type_of_trip_component > .controls > .multiple-choice > li').click(function () {
		updateQuestionsVisibility(pagination, readOnly);
	});

	/**
  * Callback for Traveller Type basic question.
  */
	$('#recommend_component > .controls > .multiple-choice > li').click(function () {
		updateQuestionsVisibility(pagination, readOnly);
	});

	updateQuestionsVisibility(pagination, readOnly);
};